// RESULTS
const swiper = new Swiper(".results", {
  loop: true,
  pagination: {
    el: ".swiper-pagination",
  },

  slidesPerView: 1,
  spaceBetween: 20,
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    1000: {
      loop: false,
      slidesPerView: 3,
      spaceBetween: 30,
    },
  },
});

// COLLABO
const collabo = new Swiper(".collabo", {
  loop: true,
  pagination: {
    el: ".swiper-pagination",
  },

  slidesPerView: 1.2,
  spaceBetween: 10,
  centeredSlides: true,
  breakpoints: {
    640: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    1000: {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 10,
    },
  },
});


// MODAL
function modalActivate(trigger) {
  trigger.addEventListener("click", () => {
    const modal = document.getElementById(trigger.dataset.modal);
    if (modal) {
      modal.classList.toggle("modal--active");
      document.body.classList.toggle("body-modal--active");
    }
  });
}
const modalTrigger = document.querySelectorAll("[data-modal]");
if (modalTrigger) modalTrigger.forEach((trigger) => modalActivate(trigger));


